<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="border-0 mx-auto container-xl">
      <div class="text-container">
        <div class="title-area">
          <div class="d-flex">
            <div class="pr-2">
              <div class="survey-type-badge btn-primary">
                <fa-icon name="user" />
              </div>
            </div>
            <h1 class="page-title">
              Profile
            </h1>
          </div>
          <span class="d-block">{{ user.first_name }} {{ user.family_name }}</span>
        </div>
        <b-form @submit.prevent="profile_save">
            <b-tabs>
              <b-tab title="Contact Information">
                <div
                  class="align-self-center"
                  style="padding-top: 40px;"
                >
                  <b-form-group label="First name">
                    <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="user.first_name" />
                  </b-form-group>
                  <b-form-group label="Family name">
                    <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="user.family_name" />
                  </b-form-group>
                  <b-form-group label="E-mail">
                    <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="user.email" />
                  </b-form-group>
                  <!-- b-form-group label="Company Name">
                <b-form-input v-model="profile.company_name"></b-form-input>
              </b-form-group -->
                  <b-form-group label="Address">
                    <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="profile.address_1" />
                    <br>
                    <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="profile.address_2" />
                  </b-form-group>
                  <b-form-group label="Zip Code">
                    <b-form-input
                    :class="`${anon ? 'g-anon' : '' }`"
                      v-model="profile.zip_code"
                      size="6"
                    />
                  </b-form-group>
                  <b-form-group label="City">
                    <b-form-input :class="`${anon ? 'g-anon' : '' }`" v-model="profile.city" />
                  </b-form-group>
                  <b-form-group label="Country">
                    <b-form-select
                      v-model="profile.country_id"
                      :options="countries_options"
                    />
                  </b-form-group>
                </div>
              </b-tab>
              <!-- b-tab title="E-mail addresses">
            <div class="col-10 align-self-center" style="padding-top: 40px;">
            </div>
          </b-tab -->
            </b-tabs>
          <b-row>
            <div class="col-12 text-right">
              <b-button
                type="submit"
                variant="primary"
                @click.prevent="profile_save()"
              >
                Save
              </b-button>
            </div>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

export default {
  name: 'Profile',
  components: {
    Navbar,
    Breadcrumb
  },
  data: function () {
    return {
      countries_options: [],
      profile: null
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    user: {
      set (user) {
        return true
      },
      get () {
        // return this.$store.state.user;
        return {
          id: this.$store.state.user.id,
          i_name: this.$store.state.user.i_name,
          i_group: this.$store.state.user.i_group,
          i_email: this.$store.state.user.i_email,
          i_lang: this.$store.state.user.i_lang,
          family_name: this.$store.state.user.family_name,
          first_name: this.$store.state.user.first_name,
          email: this.$store.state.user.email
        }
      }
    }
  },
  created () {
    this.countries_get()
    this.profile_get()
    this.user_get()
  },
  methods: {
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    countries_get () {
      this.countries_options = []
      for (var i = 0; i < this.$store.state.countries.length; i++) {
        var country = {
          value: this.$store.state.countries[i].id,
          text: this.$store.state.countries[i].country_name
        }
        this.countries_options.push(country)
      }
    },
    user_get: function () {
      this.$store.dispatch('user_fetch').then(() => {
        this.user = this.$store.state.user
      })
    },
    profile_get: function () {
      this.$store.dispatch('profile_fetch').then((res) => {
        this.profile = res.data
        // this.profile = this.$store.state.profile
      })
    },
    profile_save: function () {
      this.$store.dispatch('profile_save', {
        'user': this.user,
        'profile': this.profile
      })
    }
  }
}
</script>
<style scoped>
</style>
